import { CompanyDetails } from '@/types/companies';
import { Card, Typography, Box } from '@mui/material';
import { SVCheckbox } from '@/components/core';
import { useForm, FormProvider } from 'react-hook-form';

type CompanyPermissionsProps = {
  companyDetails: CompanyDetails;
};

export default function CompanyPermissions({
  companyDetails,
}: CompanyPermissionsProps) {
  const { teammatePerms } = companyDetails;

  // Handle the case where teammatePerms might be an empty array or undefined
  // Type assertion to handle the mismatch between [] and number[]
  const permissions = (
    Array.isArray(teammatePerms) ? teammatePerms : []
  ) as number[];

  const methods = useForm({
    defaultValues: {
      create: permissions.includes(0),
      update: permissions.includes(1),
      deactivate: permissions.includes(2),
    },
  });

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
        Permissions
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
        Teammates
      </Typography>
      <FormProvider {...methods}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <SVCheckbox name="create" label="Create" disabled />
          <SVCheckbox name="update" label="Update" disabled />
          <SVCheckbox
            name="deactivate"
            label="Deactivate/Reactivate"
            disabled
          />
        </Box>
      </FormProvider>
    </Card>
  );
}
